var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBankFindFinancials = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "277px",
    height: "122px",
    viewBox: "0 0 277 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BFS_Financials_new") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BFS_Financials_new"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(183.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#FFFFFF",
    stroke: "#003A5D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 9,
    y: 9,
    width: 84,
    height: 105
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 5,
    y: 5,
    width: 84,
    height: 105
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 1,
    y: 1,
    width: 84,
    height: 105
  })), /*#__PURE__*/React.createElement("text", {
    id: "$",
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontSize: 33,
    fontWeight: "bold",
    fill: "#003A5D"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 34,
    y: 33
  }, "$")), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(46.000000, 46.500000)",
    stroke: "#CED6E3",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.10542736e-15,0.5 L30,0.5",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.10542736e-15,15.5 L30,15.5",
    id: "Line-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.10542736e-15,29.5 L30,29.5",
    id: "Line-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.10542736e-15,44.5 L30,44.5",
    id: "Line-Copy-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(10.000000, 46.500000)",
    stroke: "#CED6E3",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.10542736e-15,0.5 L30,0.5",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.10542736e-15,15.5 L30,15.5",
    id: "Line-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.10542736e-15,29.5 L30,29.5",
    id: "Line-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.10542736e-15,44.5 L30,44.5",
    id: "Line-Copy-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(123.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,14 L37.5,14",
    id: "Line-2",
    stroke: "#003A5D",
    strokeWidth: 8,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#003A5D",
    transform: "translate(37.000000, 14.000000) rotate(90.000000) translate(-37.000000, -14.000000) ",
    points: "37 0 51 28 23 28"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.00062769,34.0352941 L2.00062769,39.9529412 C1.97764758,40.5128372 2.58848716,40.9808168 3.36732213,41 L115.632678,41 C116.411513,40.9808168 117.022352,40.5128372 116.999372,39.9529412 L116.999372,34.0352941 C117.013233,33.4799344 116.404984,33.0191748 115.632678,33 L3.35913833,33 C2.59006172,33.0222945 1.98665467,33.4821387 2.00062769,34.0352941 L2.00062769,34.0352941 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00048363,109.474026 L4.00048363,104.525974 C3.99381661,104.390526 4.05630526,104.258624 4.17397132,104.159773 C4.29163655,104.060923 4.45466031,104.003374 4.62657288,104 L114.373427,104 C114.54534,104.003374 114.708363,104.060923 114.826029,104.159773 C114.943695,104.258624 115.006183,104.390526 114.999516,104.525974 L114.999516,109.474026 C115.006183,109.609474 114.943695,109.741376 114.826029,109.840227 C114.708363,109.939077 114.54534,109.996626 114.373427,110 L4.62657288,110 C4.45466031,109.996626 4.29163655,109.939077 4.17397132,109.840227 C4.05630526,109.741376 3.99381661,109.609474 4.00048363,109.474026 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0005375,51.2921348 L39.0005375,45.6980337 C38.996188,45.5180976 39.0508053,45.3434365 39.1523623,45.2125129 C39.2539185,45.0815893 39.3940865,45.00514 39.5419982,45 L49.4580018,45 C49.6059135,45.00514 49.7460815,45.0815893 49.8476377,45.2125129 C49.9491947,45.3434365 50.003812,45.5180976 49.9994625,45.6980337 L49.9994625,51.2921348 C50.0060182,51.4737396 49.9523869,51.6509473 49.8505948,51.7840227 C49.7488026,51.917098 49.6073666,51.994906 49.4580018,52 L39.5419982,52 C39.3926334,51.994906 39.2511974,51.917098 39.1494052,51.7840227 C39.0476131,51.6509473 38.9939818,51.4737396 39.0005375,51.2921348 L39.0005375,51.2921348 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0006013,51.2921348 L10.0006013,45.6980337 C9.9962519,45.5180976 10.0508687,45.3434365 10.152425,45.2125129 C10.2539805,45.0815893 10.3941476,45.00514 10.5420582,45 L20.4660745,45 C20.7709018,45.0159722 21.0085763,45.3270191 20.99945,45.6980337 L20.99945,51.2921348 C21.0060218,51.4720946 20.9534875,51.6478448 20.8534312,51.7806338 C20.7533748,51.9134228 20.6140135,51.9923454 20.4660745,52 L10.5178139,52 C10.2161416,51.9737279 9.98667942,51.6596826 10.0006013,51.2921348 L10.0006013,51.2921348 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0002079849,121.246753 L0.0002079849,114.753247 C-0.00905273422,114.35004 0.29208286,114.014118 0.675451599,114 L118.332534,114 C118.516027,114.006767 118.689434,114.08996 118.814547,114.231248 C118.93966,114.372538 119.006213,114.560329 118.999543,114.753247 L118.999543,121.246753 C119.006213,121.439671 118.93966,121.627462 118.814547,121.768752 C118.689434,121.91004 118.516027,121.993233 118.332534,122 L0.675451599,122 C0.29208286,121.985882 -0.00905273422,121.64996 0.0002079849,121.246753 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.00055,51.2921348 L98.00055,45.6980337 C97.9914236,45.3270191 98.2290995,45.0159722 98.5339286,45 L108.458002,45 C108.605914,45.00514 108.746082,45.0815893 108.847638,45.2125129 C108.949195,45.3434365 109.003812,45.5180976 108.999462,45.6980337 L108.999462,51.2921348 C109.006018,51.4737396 108.952387,51.6509473 108.850595,51.7840227 C108.748803,51.917098 108.607367,51.994906 108.458002,52 L98.5339286,52 C98.3859888,51.9923454 98.2466267,51.9134228 98.1465697,51.7806338 C98.0465127,51.6478448 97.9939782,51.4720946 98.00055,51.2921348 L98.00055,51.2921348 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0005375,51.2921348 L68.0005375,45.6980337 C67.996188,45.5180976 68.0508052,45.3434365 68.1523621,45.2125129 C68.2539182,45.0815893 68.394086,45.00514 68.5419976,45 L78.4660714,45 C78.6132944,45.0050922 78.7526751,45.0818643 78.8529519,45.2130965 C78.9532287,45.3443287 79.0060073,45.5190366 78.99945,45.6980337 L78.99945,51.2921348 C79.0060218,51.4720946 78.9534873,51.6478448 78.8534303,51.7806338 C78.7533733,51.9134228 78.6140112,51.9923454 78.4660714,52 L68.5419976,52 C68.392633,51.994906 68.2511971,51.917098 68.1494051,51.7840227 C68.047613,51.6509473 67.9939818,51.4737396 68.0005375,51.2921348 L68.0005375,51.2921348 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,99.6891938 L12,55.310807 C12.1732624,55.0363791 12.3561974,54.9421843 12.5372279,55.0341831 L18.4627721,55.0341831 C18.6438026,54.9421843 18.8267376,55.0363791 19,55.310807 L19,99.6891938 C18.8267376,99.9636206 18.6438026,100.057815 18.4627721,99.9658178 L12.5372279,99.9658178 C12.3561974,100.057815 12.1732624,99.9636206 12,99.6891938 L12,99.6891938 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,99.6891938 L41,55.310807 C41.1730642,55.0363791 41.3557898,54.9421843 41.5366133,55.0341831 L47.4633867,55.0341831 C47.6442102,54.9421843 47.8269358,55.0363791 48,55.310807 L48,99.6891938 C47.8269358,99.9636206 47.6442102,100.057815 47.4633867,99.9658178 L41.5366133,99.9658178 C41.3557898,100.057815 41.1730642,99.9636206 41,99.6891938 L41,99.6891938 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,99.6877078 L100,55.3122924 C100.170786,55.0399613 100.351225,54.9457582 100.529817,55.035687 L106.470183,55.035687 C106.648776,54.9409852 106.829417,55.0352942 107,55.3122924 L107,99.6877078 C106.829417,99.9647044 106.648776,100.059015 106.470183,99.9643132 L100.505734,99.9643132 C100.335098,100.037989 100.163188,99.9439669 100,99.6877078 L100,99.6877078 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,99.6891938 L70,55.310807 C70.1732624,55.0363791 70.3561974,54.9421843 70.5372279,55.0341831 L76.4627721,55.0341831 C76.6438026,54.9421843 76.8267376,55.0363791 77,55.310807 L77,99.6891938 C76.8267376,99.9636206 76.6438026,100.057815 76.4627721,99.9658178 L70.5372279,99.9658178 C70.3561974,100.057815 70.1732624,99.9636206 70,99.6891938 L70,99.6891938 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2877139,0.0612548342 L13.1717261,28.3169922 C13.0317513,28.4094396 12.969227,28.570808 13.0146138,28.7224843 C13.0600005,28.8741606 13.2038577,28.9845999 13.3761047,29 L105.60808,29 C105.78615,28.9933213 105.938931,28.8826391 105.985666,28.726456 C106.032401,28.5702727 105.962317,28.4045944 105.812459,28.3169922 L59.6964711,0.0612548342 C59.5750596,-0.0204182781 59.4091254,-0.0204182781 59.2877139,0.0612548342 Z M60.2523809,20.7890579 L60.2523809,22.4965775 L58.5437758,22.4965775 L58.5437758,20.8929939 C57.5091982,20.8611156 56.4977294,20.6066743 55.5925488,20.1505941 L56.1075829,18.1758106 C56.9836804,18.6498581 57.9818491,18.9059191 59.0015839,18.9182104 C59.9907763,18.9182104 60.6366127,18.5470105 60.6366127,17.8714266 C60.6366127,17.1958428 60.0807029,16.8320669 58.7890301,16.386627 C56.9332724,15.7778591 55.6579499,14.9018273 55.6579499,13.3056677 C55.6862744,11.7878325 56.9418024,10.5209789 58.6010018,10.3360684 L58.6010018,8.75475678 L60.3014318,8.75475678 L60.3014318,10.2395564 C61.1781571,10.2553078 62.0404272,10.4453668 62.8275513,10.7963563 L62.3206924,12.6968999 C61.549061,12.3276701 60.6912668,12.1316526 59.8190983,12.125252 C58.6909284,12.125252 58.3230469,12.6003879 58.3230469,13.0680998 C58.3230469,13.5358117 58.9280076,13.9812515 60.4077087,14.5157794 C62.4760201,15.2581792 63.3098848,16.156483 63.3098848,17.6709787 C63.3092529,19.2641846 61.9949734,20.6045022 60.2523809,20.7890579 Z",
    id: "Shape",
    fill: "#003A5D",
    fillRule: "nonzero"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBankFindFinancials);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BankFind_Financials.6a1d243bc611540156643bb41b522686.svg";